class ScheduleSummaryController {

    constructor() {
        this.view = new ScheduleSummaryView();
    }

    update(schedule) {

        let details = plannerApplication.yourProfile.getYourDetails();
        this.view.firstName.html(details.getFirstName());
        this.view.lastName.html(details.getLastName());
        this.view.email.html(details.getEmail()).attr('href','mailto://'+details.getEmail());

        let thisObj = this;
        let freeTime = 24 * 7;
        this.view.items.each(function (i, item) {
            freeTime -= thisObj.updateSummaryForItem(schedule, item);
        });
        if(freeTime < 0) {
            freeTime = 0;
        }
        this.view.findItem(ScheduleType.free).update(freeTime);

        let hrsStudy = schedule.totalHoursForType(ScheduleType.study);
        let remainingHrs = plannerApplication.yourProfile.getSelectedCourse().getHours() - hrsStudy;
        if(remainingHrs < 0) {
            remainingHrs = 0;
        }
        this.view.updateRemainingStudyTime(remainingHrs);
    }

    updateSummaryForItem(schedule, item) {

        let scheduleType = item.scheduleType;
        let hrs = schedule.totalHoursForType(scheduleType);
        item.update(hrs);
        item.rootNode.showAnimatedIf(hrs >0);
        return hrs;
    }
}
